import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './ui/layout/layout.component';
//import { LoginComponent } from './auth/login/login.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { RegisterComponent } from './auth/register/register.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { AccessListComponent } from './access/access-list/access-list.component';
import { StudyListComponent } from "./study/study-list/study-list.component";
import { StudyCRCListComponent } from "./study/study-crc-list/study-crc-list.component";
import { AddUserCopyComponent } from "./users/add-user-copy/add-user.component";
import { StudyCRCEditComponent } from "./study/study-crc-edit/study-crc-edit.component";
import { StudyViewComponent } from "./study/study-crc-view/study-crc-view.component";
import { ViewUserComponent } from './users/view-user/view-user.component';
import { ViewStudyComponent } from './study/view-visits/view-study.component';
import { EditStudyComponent } from './study/edit-study/edit-study.component';
import { EmailLoginComponent } from './auth/email-login/email-login.component';
import { StudyCRCMonitoringComponent } from './study/study-crc-monitoring/study-crc-monitoring.component';
import { ExportexcelComponent } from './study/exportexcel/exportexcel.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { StudyDetailsComponent } from './study-details/study-details.component';
import { FoldersComponent } from './study/folders/folders.component';
import { VisitsComponent } from './study/visits/visits.component';
import { BuildEcrfComponent } from './study/build-ecrf/build-ecrf.component';
import { EcrfTemplateComponent } from './study/ecrf-template/ecrf-template.component';
import { StudyTemplateComponent } from './study/study-template/study-template.component';

import { ScreeningVisitsComponent } from './study/folders/screening-visits/screening-visits.component';
import { BaselineVisitsComponent } from './study/folders/baseline-visits/baseline-visits.component';
import { MedicineDispensingVisitComponent } from './study/folders/medicine-dispensing-visit/medicine-dispensing-visit.component';
import { StudyCompletionTerminationComponent } from './study/folders/study-completion-termination/study-completion-termination.component';
import { FollowupVisitComponent } from './study/folders/follow-up-visit/follow-up-visit.component';
import { PrincipalInvestigatorSignatureComponent } from './study/folders/principal-investigator-signature/principal-investigator-signature.component';
import { ProtocolDeviationComponent } from './study/folders/protocol-deviation/protocol-deviation.component';
import {AdverseEventsComponent} from './study/folders/adverse-events/adverse-events.component';

import { ConcomitantMedicationLogComponent } from './study/folders/concomitant-medication-log/concomitant-medication-log.component';
import {PriorMedicationLogComponent} from './study/folders/prior-medication-log/prior-medication-log.component';
import {RescueMedicationLogComponent} from './study/folders/rescue-medication-log/rescue-medication-log.component';
import { MedicalHistoryComponent } from './study/folders/medical-history/medical-history.component';
import { VitalSignsComponent } from './study/folders/vital-signs/vital-signs.component';
//import { SubjectManagementComponent } from './subject-management/subject-management.component';
import { PHYSICALANDSYSTEMICEXAMINATIONComponent } from './study/folders/physical-and-systemic-examination/physical-and-systemic-examination.component';
import { LaboratoryInvestigationComponent } from './study/folders/laboratory-investigation/laboratory-investigation.component';
import { IdrsComponent } from './study/folders/idrs/idrs.component';
import { ScheduleOfActivitiesComponent } from './study/folders/schedule-of-activities/schedule-of-activities.component';
import { EcrfListComponent } from './study/ecrf-list/ecrf-list.component';
import { SiteListComponent } from './study/site-list/site-list.component';
import { AddLocationComponent } from './study/add-location/add-location.component';
import { SubscriptionsComponent } from './study-management/subscriptions/subscriptions.component';
import { DataViewComponent } from './study-management/data-view/data-view.component';
import { QueryViewComponent } from './study-management/query-view/query-view.component';
import { AuditTrailComponent } from './study-management/audit-trail/audit-trail.component';
import { SystemAuditTrailComponent } from './study-management/system-audit-trail/system-audit-trail.component';

import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/project-explanation/project-explanation.module').then((m) => m.ProjectExplanationModule),
  },
  {
    path: '',
    component: LayoutComponent,
     canActivate: [AuthGuard], 
      canActivateChild: [AuthGuard], 
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'access-list', component: AccessListComponent
      },
      {
        path: 'users-list', component: UsersListComponent
      },
      {
        path: 'pie-chart', component: PieChartComponent
      },
      {
        path: 'view-user/:id', component: ViewUserComponent
      },
      {
        path: 'study-list', component: StudyListComponent
      },
      {
        path: 'build-ecrf', component: BuildEcrfComponent
      },
      {
        path: 'ecrf-template/:id', component: EcrfTemplateComponent
      },
      {
        path: 'study-template', component: StudyTemplateComponent
      },
      {
        path: 'study-details/:id', component: StudyDetailsComponent
      },
      {
        path: 'folders', component: FoldersComponent
      },
      {
        path: 'visits', component: VisitsComponent
      },
      {
        path: 'study-crc-list', component: StudyCRCListComponent
      },
      {
        path: 'view-visits/:id', component: ViewStudyComponent
      },
      {
        path: 'edit-study', component: EditStudyComponent
      },
      {
        path: 'add-user', component: AddUserCopyComponent
      },
      {
        path: 'study-crc-edit/:id', component: StudyCRCEditComponent
      },
      {
        path: 'study-crc-view/:id', component: StudyViewComponent
      },
      {
        path: 'study-crc-monitoring/:id', component: StudyCRCMonitoringComponent
      },
      { path: 'exportexcel/:study_crc_id', component: ExportexcelComponent },
      {
        path: 'about',
        loadChildren: () =>
          import('./pages/about/about.module').then((m) => m.AboutModule),
      },
      {
        path: 'subscriptions', component: SubscriptionsComponent
      },
      {
        path: 'data-view', component: DataViewComponent
      },
      {
        path: 'query-view', component: QueryViewComponent
      },
      {
        path: 'audit-trail', component: AuditTrailComponent
      },
      {
        path: 'system-audit-trail', component: SystemAuditTrailComponent
      },
      {
        path: 'site-list', component: SiteListComponent
      },
      {
        path: 'add-location', component: AddLocationComponent 
      },
      {
        path: 'ecrf-list', component: EcrfListComponent
      },
    ],
  },
  {
    path: 'forgot', component: ForgotComponent
  },
  {
    path: 'register', component: RegisterComponent
  },
  {
    path: 'email-login', component: EmailLoginComponent
  },
  {
    path: 'project-explanation',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'project-explanation',
    loadChildren: () =>
      import('./pages/project-explanation/project-explanation.module').then((m) => m.ProjectExplanationModule),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./pages/contact-us/contact-us.module').then((m) => m.ContactUsModule),
  },
  {
    path: 'registration',
    loadChildren: () =>
      import('./pages/registration/registration.module').then((m) => m.RegistrationModule),
  },
{
  path: 'folders/principal-investigator-signature/:formName',
  component: PrincipalInvestigatorSignatureComponent
},
{
  path: 'folders/idrs/:formName',
  component: IdrsComponent
},
{
  path: 'folders/schedule-of-activities/:formName',
  component:ScheduleOfActivitiesComponent
},
{
  path: 'folders/laboratory-investigation-log/:formName',
  component: LaboratoryInvestigationComponent
},
{
  path: 'folders/vital-signs/:formName',
  component: VitalSignsComponent
},
{
  path: 'folders/physical-systemic/:formName',
  component: PHYSICALANDSYSTEMICEXAMINATIONComponent
},
{
  path: 'folders/concomitant-medication/:formName',
  component: ConcomitantMedicationLogComponent
},
{
  path: 'folders/medical-history/:formName',
  component: MedicalHistoryComponent
},
{
  path: 'folders/rescue-medication/:formName',
  component: RescueMedicationLogComponent
},
{
  path: 'folders/prior-medication/:formName',
  component: PriorMedicationLogComponent
},
{
  path: 'folders/protocol-deviation/:formName',
  component: ProtocolDeviationComponent
},
{
  path: 'folders/adverse-events/:formName',
  component: AdverseEventsComponent
},
{
  path: 'folders/follow-up-visit/:formName',
  component: FollowupVisitComponent
},
{
  path: 'folders/baseline-visits/:formName',
  component: BaselineVisitsComponent
},
{
  path: 'folders/medicine-dispensing-visit/:formName',
  component: MedicineDispensingVisitComponent
},
{
  path: 'folders/study-completion-termination/:formName',
  component:StudyCompletionTerminationComponent
},
{
  path: 'folders/:foldername/:formName',
  component: ScreeningVisitsComponent
},
{
  path: 'ecrf-template/:templateId/folders/:formName',
  component: ScreeningVisitsComponent
}, 
{
    path: 'build-ecrf',
    redirectTo: 'ecrf-list',
    pathMatch: 'full'
  }, 
  {
    path: 'build-ecrf', 
    component: EcrfListComponent
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }